import { useContext } from 'react'
import { CashCountContext } from '@/contexts'

export const useCashCount = () => useContext(CashCountContext)
